import type { SignupAudience } from '@monolith/legacy/types/signup-audience';

/**
 * Surface the signup email step is rendered on. `legacy_login_modal` is the auth
 * popin, which was the only host until the brand acquisition landing started
 * rendering the same step inline, on the page, with no modal above it.
 */
export type SignupModalVariant = 'legacy_login_modal' | 'brand_registration_page';

/**
 * Where the visitor entered that surface from. Distinct from `SignUpProps.source`, which
 * is the OriginProperty vocabulary (home page, lift page) the funnel events use.
 */
export type SignupModalSource = 'product_card' | 'brand_registration_page';

export interface SignUpProperty extends SignUpProps {
  type: string;
  errors?: { [key: string]: any };
  version?: 1 | 2;
}
export interface SignUpProps {
  is_opening_soon?: boolean;
  is_personalized?: boolean;
  is_reminded?: boolean;
  is_prefilled?: boolean;
  source?: string;
  modal_variant?: SignupModalVariant;
  /**
   * Read only by SignupModalEvent (createSignUpProperty deliberately drops it), so the
   * surface context travels with the rest of the funnel context instead of as a second
   * prop every host in the chain would have to forward.
   */
  modal_source?: SignupModalSource;
  has_usp_block?: boolean;
  audience: SignupAudience;
  step?: 1 | 2;
}

export function createSignUpProperty({
  type,
  errors,
  is_opening_soon,
  is_personalized,
  is_reminded,
  is_prefilled,
  modal_variant,
  has_usp_block,
  audience,
  step,
}: SignUpProperty): SignUpProperty {
  return {
    type,
    errors,
    is_opening_soon,
    is_personalized,
    is_reminded,
    is_prefilled,
    modal_variant,
    has_usp_block,
    // Required, never inferred: the emitting code path states which funnel the
    // interaction belongs to, so a missing audience is a compile error rather
    // than a plausible-but-wrong default.
    audience,
    step,
  };
}
